import { render, staticRenderFns } from "./content-section.vue?vue&type=template&id=1195875e&scoped=true&"
import script from "./content-section.vue?vue&type=script&lang=js&"
export * from "./content-section.vue?vue&type=script&lang=js&"
import style0 from "./content-section.vue?vue&type=style&index=0&id=1195875e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195875e",
  null
  
)

export default component.exports